import { render, staticRenderFns } from "./TradeUrlInput.vue?vue&type=template&id=15fcbbf6&"
import script from "./TradeUrlInput.vue?vue&type=script&lang=ts&"
export * from "./TradeUrlInput.vue?vue&type=script&lang=ts&"
import style0 from "./TradeUrlInput.vue?vue&type=style&index=0&id=15fcbbf6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QBtn});
